<template>
  <v-dialog v-model="dialogLoading.open" persistent content-class="small">
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
              <p class="m-b-20" v-html="dialogLoading.text"></p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="80"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialogLoadingCampaignVoice',
  props: {
    dialogLoading: Object
  }
}
</script>
